const admin = {
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome to administration",
    selectModule: "Select a module to manage your content",
    modules: {
      projects: "Manage your portfolio projects",
      blog: "Manage your blog posts",
      experiences: "Manage your professional experiences",
      skills: "Manage your expertise and soft skills",
      activities: "Manage your talks and meetups",
      technologies: "Manage your tech stack",
      cases: "Manage your case studies",
      messages: "View contact messages",
    },
    stats: {
      projects: "Projects",
      experiences: "Experiences",
      skills: "Skills",
      messages: "Messages",
    },
  },

  sections: {
    projects: "Projects",
    experiences: "Experiences",
    technologies: "Technologies",
    skills: "Skills",
    blog: "Blog",
    activities: "Activities",
    cases: "Cases",
    services: "Services",
    labs: "Labs",
    messages: "Messages",
  },

  actions: {
    create: "Create",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    publish: "Publish",
    unpublish: "Unpublish",
    back: "Back",
    confirm: "Confirm",
    logout: "Logout",
    reply: "Reply",
    close: "Close",
  },

  labels: {
    title: "Title",
    description: "Description",
    content: "Content",
    excerpt: "Excerpt",
    category: "Category",
    status: "Status",
    published: "Published",
    draft: "Draft",
    date: "Date",
    order: "Order",
    company: "Company",
    role: "Role",
    startDate: "Start Date",
    endDate: "End Date",
    isCurrent: "Current Position",
    name: "Name",
    level: "Level",
    yearsExperience: "Years of Experience",
    actions: "Actions",
    slug: "Slug",
    client: "Client",
    coverImageUrl: "Cover Image URL",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    read: "Read",
    unread: "Unread",
    skills: "Skills",
    technologies: "Technologies",
    select: "Select...",
  },

  messages: {
    confirmDelete: "Are you sure you want to delete this item?",
    confirmDeleteTitle: "Confirm deletion",
    confirmDeleteMessage:
      'Are you sure you want to delete the message from "{{name}}"?',
    slugHelper: "Unique identifier for the URL (e.g., my-post)",
    messageFrom: "Message from {{name}}",
    saveSuccess: "Successfully saved",
    saveError: "Error saving",
    deleteSuccess: "Successfully deleted",
    deleteError: "Error deleting",
    loading: "Loading data...",
    noData: "No data found",
  },

  translations: {
    title: "Translations",
    french: "Français",
    english: "English",
    tabs: {
      fr: "French",
      en: "English",
    },
  },

  skills: {
    categories: {
      aiMl: "AI / ML",
      backend: "Backend",
      frontend: "Frontend",
      cloud: "Cloud",
      other: "Other",
    },
    levels: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      expert: "Expert",
    },
  },

  technologiesMeta: {
    categories: {
      frontend: "Frontend",
      backend: "Backend",
      language: "Programming Language",
      database: "Database",
      devops: "DevOps",
      mobile: "Mobile",
      aiMl: "AI / ML",
      cloud: "Cloud",
      integration: "Integration / API / MCP",
      tools: "Tools",
      other: "Other",
    },
    proficiency: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced",
      expert: "Expert",
    },
  },

  casesMeta: {
    clientName: "Client Name",
    caseLabel: "Case Label (Type)",
  },
};

export default admin;
